import { Colour } from '../Colour/Colour';
import { PointOps } from "../Graphics/PointOps";
import { Point } from "../Misc/Utils";

export class Line {

    private defaultWidth = 1
    private defaultColor = 'orange'

    constructor(){
    }

    setLineWidth(width: number){
        this.defaultWidth = width;
    }

    setColour(circleColor: Colour){
        this.defaultColor = circleColor.getColor();
    }

    drawLine(canvasCtx : CanvasRenderingContext2D, start : Point, end: Point){
        this.draw(canvasCtx, start, end, this.defaultWidth, this.defaultColor);
    }

    draw(canvasCtx : CanvasRenderingContext2D, startPos : Point, endPos: Point, lineWidth : number, color : string){
        canvasCtx.strokeStyle = color;
        canvasCtx.beginPath();
        canvasCtx.moveTo(startPos[0], startPos[1]);
        canvasCtx.lineTo(endPos[0], endPos[1]);
        canvasCtx.lineWidth = lineWidth;
        canvasCtx.stroke();
    }

    contains(point : Point, centre : Point, radius : number) : boolean{
        return PointOps.containedInCircle(point, centre, 2*radius);
    }

    private getPath(centre : Point, radius : number) : Path2D{
        var path2d = new Path2D();
        path2d.arc(centre[0], centre[1], radius, 0, 2*Math.PI);
        return path2d;
    }
}